var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTextMode(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 286,
    height: 166,
    viewBox: "0 0 286 166",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M160.27 161.836L6.88731 73.2808C3.11447 71.1026 3.11474 67.5584 6.88757 65.3801L111.982 4.70361C115.755 2.52536 121.894 2.5252 125.667 4.70345L279.05 93.259C282.822 95.4373 282.822 98.9817 279.05 101.16L173.955 161.836C170.182 164.015 164.043 164.015 160.27 161.836Z",
    fill: "#FEFEFE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M124.567 5.33842C121.401 3.51035 116.249 3.51035 113.082 5.33858L7.98737 66.0151C4.82079 67.8433 4.8208 70.8178 7.9871 72.6459L161.37 161.201C164.536 163.03 169.688 163.03 172.855 161.201L277.95 100.525C281.116 98.6967 281.116 95.7221 277.95 93.894L124.567 5.33842ZM160.27 161.836L6.88731 73.2808C3.11447 71.1026 3.11474 67.5584 6.88757 65.3801L111.982 4.70361C115.755 2.52536 121.894 2.5252 125.667 4.70345L279.05 93.259C282.822 95.4373 282.822 98.9817 279.05 101.16L173.955 161.836C170.182 164.015 164.043 164.015 160.27 161.836Z",
    fill: "#A7A7A7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M262.644 109.7L96.9345 14.0281C96.6309 13.8528 96.6309 13.5684 96.9345 13.3931C97.238 13.2179 97.7307 13.2179 98.0343 13.3931L263.744 109.065C264.047 109.241 264.047 109.525 263.744 109.7C263.44 109.876 262.947 109.876 262.644 109.7Z",
    fill: "#A7A7A7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M132.531 18.6215C131.149 17.8235 128.9 17.8235 127.518 18.6215C126.135 19.4197 126.136 20.718 127.518 21.516C128.9 22.314 131.149 22.3142 132.531 21.516C133.913 20.718 133.913 19.4195 132.531 18.6215ZM126.418 22.151C124.429 21.0028 124.429 19.1347 126.418 17.9866C128.407 16.8384 131.642 16.8384 133.631 17.9866C135.62 19.1347 135.62 21.0028 133.631 22.151C131.642 23.2992 128.407 23.2992 126.418 22.151Z",
    fill: "#A7A7A7"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M142.937 24.6294C141.555 23.8315 139.306 23.8313 137.923 24.6293C136.541 25.4274 136.542 26.7259 137.924 27.5239C139.306 28.3219 141.555 28.3221 142.937 27.5239C144.319 26.7259 144.319 25.4274 142.937 24.6294ZM136.824 28.1589C134.835 27.0107 134.835 25.1425 136.824 23.9943C138.812 22.8461 142.048 22.8463 144.037 23.9945C146.026 25.1427 146.026 27.0107 144.037 28.1589C142.048 29.3071 138.813 29.3071 136.824 28.1589Z",
    fill: "#A7A7A7"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M122.675 15.8256C120.987 16.8002 118.25 16.8001 116.562 15.8256C114.874 14.8509 114.874 13.2708 116.562 12.2961C118.25 11.3214 120.987 11.3214 122.675 12.2961C124.363 13.2706 124.363 14.8509 122.675 15.8256Z",
    fill: "#FF6600"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M122.125 12.6137C120.743 11.8157 118.494 11.8157 117.112 12.6137C115.73 13.4118 115.73 14.7102 117.112 15.5081C118.494 16.3061 120.743 16.3063 122.125 15.5081C123.508 14.7102 123.508 13.4117 122.125 12.6137ZM116.012 16.1431C114.023 14.9949 114.023 13.1269 116.012 11.9787C118.001 10.8305 121.236 10.8305 123.225 11.9787C125.214 13.1269 125.214 14.9949 123.225 16.1431C121.236 17.2913 118.001 17.2913 116.012 16.1431Z",
    fill: "#A7A7A7"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M133.947 81.3464L142.042 76.6729L145.005 83.0568L147.968 89.4411L136.91 87.7303L125.853 86.0197L133.947 81.3464Z",
    fill: "#FEFEFE"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1653_68766)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 151.21,
    height: 85.4166,
    rx: 5.56565,
    transform: "matrix(0.866025 0.5 -0.866025 0.5 89.2354 4.16473)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 84.4124,
    height: 5.56565,
    rx: 2.78283,
    transform: "matrix(0.866025 0.5 -0.866025 0.5 93.4907 15.1312)",
    fill: "#0889C6"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 121.517,
    height: 3.71044,
    rx: 1.85522,
    transform: "matrix(0.866025 0.5 -0.866025 0.5 80.6377 22.5521)",
    fill: "#CFCFCF"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 121.517,
    height: 3.71044,
    rx: 1.85522,
    transform: "matrix(0.866025 0.5 -0.866025 0.5 73.4077 26.7263)",
    fill: "#CFCFCF"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 121.517,
    height: 3.71044,
    rx: 1.85522,
    transform: "matrix(0.866025 0.5 -0.866025 0.5 66.1777 30.9006)",
    fill: "#CFCFCF"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 121.517,
    height: 3.71044,
    rx: 1.85522,
    transform: "matrix(0.866025 0.5 -0.866025 0.5 58.9478 35.0749)",
    fill: "#CFCFCF"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 121.517,
    height: 3.71044,
    rx: 1.85522,
    transform: "matrix(0.866025 0.5 -0.866025 0.5 51.7178 39.2491)",
    fill: "#CFCFCF"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 121.517,
    height: 3.71044,
    rx: 1.85522,
    transform: "matrix(0.866025 0.5 -0.866025 0.5 44.4878 43.4233)",
    fill: "#CFCFCF"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 65.8602,
    height: 3.71044,
    rx: 1.85522,
    transform: "matrix(0.866025 0.5 -0.866025 0.5 37.2578 47.5975)",
    fill: "#CFCFCF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -2.76449e-8,
    y: 0.463804,
    width: 150.283,
    height: 84.489,
    rx: 5.10185,
    transform: "matrix(0.866025 0.5 -0.866025 0.5 89.637 4.39664)",
    stroke: "#A5A5A5",
    strokeWidth: 0.927609
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1653_68766",
    x: 2.27568,
    y: 4.16473,
    width: 230.898,
    height: 152.635,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 21.335
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.49326
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1653_68766"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1653_68766",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTextMode);
export default __webpack_public_path__ + "static/media/text-mode.acef7867ce6d38597e2f03c35c831c8e.svg";
export { ForwardRef as ReactComponent };